/**
 * @file MyAssets.js
 * @description This component renders the generic Asset Library component passing "MyAssets" as a viewMode prop to display the individual's personal assets and other assets shared with them.
 */

import AssetLibrary from "./AssetLibrary";

const MyAssets = () => {

    return (
        <>
        <AssetLibrary viewMode="MyAssets"></AssetLibrary>
        </>
    );
};

export default MyAssets;


